import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from '@gameday/utils/hooks/useTranslate';
import { ConnectionStatus, EllipsesContainer } from './ConnectionError.style';
import useTracking from '@gameday/utils/hooks/useTracking';

const ConnectionError = ({ errorStatus }) => {
    const translate = useTranslate();
    const Tracking = useTracking();

    const connectionErrorText = translate('attempting_to_reconnect', 'Attempting to reconnect');

    const trackContainerAction = useCallback(() => {
        const cfg = {
            componentName: ['Connection Error'],
            activity: 'Connection Lost'
        };

        Tracking.track.track_click(cfg);
    }, [Tracking]);

    useEffect(() => {
        if (errorStatus) {
            trackContainerAction();
        }
    }, [errorStatus]);

    return (
        <ConnectionStatus $errorStatus={errorStatus}>
            <span>{ connectionErrorText }<EllipsesContainer /></span>
        </ConnectionStatus>
    );
};

ConnectionError.propTypes = {
    errorStatus: PropTypes.bool
};

export default ConnectionError;
